import React from "react";

/**
 * Column definitions for the Admin module data tables
 */

export const ROLE_BADGE_COLORS = {
  ADMIN: "danger",
  MANAGER: "warning",
  USER: "info",
};

export const adminColumnDefinitions = {
  users: [
    { name: "ID", selector: (row) => row.id, sortable: true, width: "70px" },
    { name: "Username", selector: (row) => row.userName, sortable: true, width: "150px" },
    { name: "Email", selector: (row) => row.email, sortable: true, width: "150px" },
    {
      name: "User Type",
      selector: (row) => row.userType,
      width: "150px",
      sortable: true,
      cell: (row) => {
        return (
          <span className={`badge badge-${ROLE_BADGE_COLORS[row.userType] || "secondary"}`}>
            {row.userType}
          </span>
        );
      },
    },
    {
      name: "Status",
      selector: (row) => row.active,
      width: "150px",
      sortable: true,
      cell: (row) => (
        <span className={`badge badge-${row.active ? "success" : "secondary"}`}>
          {row.active ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      name: "Verified",
      selector: (row) => row.verified,
      sortable: true,
      width: "100px",
      cell: (row) => (
        <span className={`badge badge-${row.verified ? "success" : "warning"}`}>
          {row.verified ? "Yes" : "No"}
        </span>
      ),
    },
    {
      name: "Admin Access",
      selector: (row) => row.canAccessAdminPanel,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <span className={`badge badge-${row.canAccessAdminPanel ? "success" : "danger"}`}>
          {row.canAccessAdminPanel ? "Yes" : "No"}
        </span>
      ),
    },
    {
      name: "Created Date",
      selector: (row) => row.createdDate,
      width: "150px",
      sortable: true,
      cell: (row) => new Date(row.createdDate).toLocaleDateString(),
    },
  ],

  partners: [
    {
      name: "UUID",
      selector: (row) => row.uuid,
      width: "200px",
      cell: (row) => (
        <span className="text-muted" style={{ fontSize: "0.85rem" }}>
          {row.uuid ? row.uuid : "N/A"}
        </span>
      ),
    },
    { name: "Name", selector: (row) => row.name, sortable: true, width: "150px"},
    {
      name: "License Usage",
      selector: (row) => row.activeLicenseCount,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div style={{ width: "100%" }}>
          <div className="d-flex justify-content-between mb-1" style={{ fontSize: "0.85rem" }}>
            <span>{row.activeLicenseCount} / {row.totalLicenseCount}</span>
            <span className="text-muted">
              {row.totalLicenseCount > 0
                ? `${((row.activeLicenseCount / row.totalLicenseCount) * 100).toFixed(0)}%`
                : "0%"}
            </span>
          </div>
          <div className="progress" style={{ height: "6px" }}>
            <div
              className={`progress-bar ${
                (row.activeLicenseCount / row.totalLicenseCount) * 100 > 80
                  ? "bg-danger"
                  : (row.activeLicenseCount / row.totalLicenseCount) * 100 > 60
                  ? "bg-warning"
                  : "bg-success"
              }`}
              style={{
                width: `${row.totalLicenseCount > 0 ? (row.activeLicenseCount / row.totalLicenseCount) * 100 : 0}%`,
              }}
            ></div>
          </div>
        </div>
      ),
    },
    {
      name: "Total Licenses",
      selector: (row) => row.totalLicenseCount,
      sortable: true,
      width: "150px",
    },
    {
      name: "Active Licenses",
      selector: (row) => row.activeLicenseCount,
      sortable: true,
      width: "150px",
    },
    {
      name: "Created By",
      selector: (row) => row.createdBy,
      sortable: true,
      width: "150px",
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <span style={{ fontSize: "0.85rem" }}>
          {row.createdAt ? new Date(row.createdAt).toLocaleDateString() : "N/A"}
        </span>
      ),
    },
  ],
};
